import { constants, typographyStyles } from "@newsela/angelou";
import type { CSSObject } from "@emotion/react";

const { ui } = constants.colors;
const { heading5Obj } = typographyStyles;

export const headingCss: CSSObject = {
  display: "flex",
  h2: {
    ...heading5Obj,
    margin: 0,
    fontWeight: 700,
    color: ui.neutral[600],
    paddingRight: ".5em",
  },
};
